import React, { Fragment, useState } from 'react'
import { DI } from 'modules'
import Component from 'components/component'
import Form from 'common/components/form/new-form'
import {
  PrimaryUrl,
  PrimarySRTUrl,
  StreamKey,
  Password,
  Username,
  IPAddress,
} from './fields'
import TVUFields from './target-tvu-fields'
import Spoiler from 'components/spoiler'
import withAnalytic from 'hoc/analytic'

export class TargetForm extends Component {
  state = {
    form: {
      key: '',
    },
  }

  onChange = (ev, form) => {
    this.setState({ form })
  }

  onSubmit = (ev, form) => {
    const onValidateForm = this.onValidateForm

    if (onValidateForm.panic()) {
      this.props.actions.targets
        .createTarget(this.props.liveEvent.slug, form)
        .then(resp => {
          this.props.close()

          this.props.trackClick(
            {
              id: this.props.liveEvent.slug,
              title: this.props.liveEvent.title,
              live_language_id: this.props.selectedLanguageID,
              live_target_type: this.props.targetType,
            },
            'book_live_addStream_complete'
          )

          return resp
        })
    }
  }

  onValidateForm = () => {}

  render() {
    const form = this.state.form
    const strings = this.props.common.strings

    return (
      <Form onChange={this.onChange} onSubmit={this.onSubmit}>
        {this.props.targetParams.map(([name, value]) => (
          <input key={name} type="hidden" name={name} value={value} />
        ))}
        <input
          type="hidden"
          name="language_id"
          value={this.props.selectedLanguageID}
        />
        <div className="popup-stream">
          <span className="popup__title">
            {strings['page.lives.view.add_stream.title']}
          </span>
          <div className="stream">
            <span className={`stream__title stream__title--${this.props.id}`}>
              {this.props.targetName}
            </span>
            <FormInner
              strings={strings}
              form={form}
              onValidateForm={this.onValidateForm}
              targetType={this.props.targetType}
              custom={this.props.custom}
              providers={this.props.targets.providers.payload}
            />
          </div>
          {this.props.children}
          <div className="popup-buttons popup-buttons--border">
            <div className="popup-button">
              <button
                type="button"
                className="text-button"
                onClick={this.props.close}
              >
                {strings['page.lives.view.add_stream.cancel']}
              </button>
            </div>
            <div className="popup-button">
              <button type="submit" className="button">
                {strings['page.lives.view.add_stream.submit']}
              </button>
            </div>
          </div>
        </div>
      </Form>
    )
  }
}

function CustomRtmpForm(props) {
  const [protocol, setProtocol] = useState()
  const onChangePrimaryUrl = evt => {
    const regexp = /^rtmps?:\/\//
    const url = evt.target.value

    if (regexp.test(url)) {
      setProtocol(url.split(':')[0])
    }
  }

  return (
    <Fragment>
      <StreamKey {...props} />
      <input type="hidden" name="provider" value={protocol} />
      <PrimaryUrl
        {...props}
        onChange={onChangePrimaryUrl}
        onBlur={onChangePrimaryUrl}
      />
      <Spoiler
        title={props.strings['page.lives.view.add_stream.optional_subtitle']}
        className="stream-manual"
        headClassName="stream-manual__head"
        bodyClassName="stream-manual-body"
      >
        <Username {...props} autocomplete="off" />
        <Password {...props} autocomplete="off" />
      </Spoiler>
    </Fragment>
  )
}

function FacebookForm(props) {
  return <StreamKey {...props} />
}

function DefaultForm(props) {
  return (
    <Fragment>
      <PrimaryUrl {...props} />
      <StreamKey {...props} />
    </Fragment>
  )
}

function SrtForm(props) {
  return <PrimarySRTUrl {...props} />
}

function HLSFullHDForm(props) {
  return <IPAddress {...props} />
}

function TVUForm(props) {
  return <TVUFields {...props} />
}

function FormInner(props) {
  return (
    <div className="stream-form">
      {['periscope', 'vkontakte', 'odnoklassniki'].includes(
        props.targetType
      ) && <DefaultForm {...props} />}
      {(props.targetType === 'facebook' || props.targetType === 'youtube') && (
        <FacebookForm {...props} />
      )}
      ){props.custom && <CustomRtmpForm {...props} />}
      {props.targetType === 'srt' && <SrtForm {...props} />}
      {props.targetType === 'hls_full_hd' && <HLSFullHDForm {...props} />}
      {props.targetType === 'tvu' && <TVUForm {...props} />}
    </div>
  )
}

export default DI(['targets'])(
  withAnalytic(TargetForm, {
    groupEvent: 'ACTION_LIVE',
    trackData: {
      location: {
        page_layout: 'live_page',
        list: 'none',
      },
    },
  })
)
